// @ts-nocheck
import React from 'react'
import QuickSetup from '../components/QuickSetup/QuickSetup'
import { ReactComponent as HomeLine } from "../assets/icons/home-line.svg";
import { ReactComponent as HurricaneIcon } from "../assets/icons/hurricane-02.svg";
import { AssetBreadCrumb } from "../components/AssetBreadCrumb";
import { useNavigate } from "react-router-dom";

const QuickSetupPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex flex-col bg-white h-screen">
      {/* Fixed header section */}
      <div className="flex-shrink-0">
        <AssetBreadCrumb text="Quick Setup">
          <HurricaneIcon stroke="#6B7280" className="w-5 h-5 ml-2 mr-1" />
        </AssetBreadCrumb>

        {/* Header section matching Group page style */}
        <div className="flex flex-row h-24 border-t border-gray-200 px-10 pt-5 justify-left">
          <div className="flex grow items-center">
            <div className="flex-col items-center justify-center">
              <div className="text-gray-900 text-xl font-semibold font-Inter mb-1">
                Quick Setup
              </div>
              <div className="text-gray-500 text-sm font-normal">
                Configure your weather forecasting problem below.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto">
        <QuickSetup />
      </div>
    </div>
  )
}

export default QuickSetupPage